import pick from 'lodash/pick';

import { connect } from 'react-redux';

import { getVisibleSelectedParametersNames, getSelectedStats } from 'store';

// REFACTOR THIS!
import { getNumericalSummary } from 'store/dataset';

import withFullScreen from 'components/FullScreenable';

import NumericalSummaryComponent from './Component';

const mapStateToProps = (state, props) => {
  const visibleParameters = getVisibleSelectedParametersNames(state);
  const numericalSummary = getNumericalSummary(state);
  const selectedColumns = getSelectedStats(state);

  return {
    summary: pick(
      numericalSummary,

      props.parameter
        ? [props.parameter]
        : visibleParameters
    ),
    selectedColumns
  };
};

export default connect(mapStateToProps)(
  withFullScreen(NumericalSummaryComponent)
);
